<deposit-end-screen-wrapper class="bp-modal mod-lg">
  <bp-modal-header header [title]="i18n.modalHeader | translate: [fiatName]">
    <a (click)="close()" right href="javascript:" (keydown.enter)="close()" [tabIndex]="0">
      {{ i18n.topRightButton | translate }}
    </a>
  </bp-modal-header>
  <div content class="withdraw-success-screen-content">
    <img class="withdraw-success-screen-img" [src]="img.url" [alt]="img.altKey | translate" />
    <div class="withdraw-success-screen-headline">{{ i18n.headline | translate }}</div>
    <p class="withdraw-success-screen-description">{{ i18n.description | translate }}</p>
    <div class="withdraw-success-screen-buttons-container">
      @for (button of callToActionButtons; track button) {
        <button
          [type]="button.type"
          [class]="button.class"
          (click)="button.action()"
          (keydown.enter)="button.action()"
          >{{ button.textI18nKey | translate }}</button
          >
        }
      </div>
    </div>
  </deposit-end-screen-wrapper>
